<script>
	import { pageNumber, model } from "../../stores";

	import PageSection from "../../components/PageSection.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";

	import Notice from "./components/Notice.svelte";
	import Signature from "./components/Signature.svelte";

	export let disabled = null;
	export let pageIndex = null;
	export let pageTitle = null;
	export let nextPage = null;
	export let nextPageLabel = null;
	export let previousPage = null;
	export let persistUrl = null;
	export let title = null;

	let stage = "optOutNotice";

	document.title = pageTitle;

	if ($pageNumber == pageIndex + 1) {
		alert("Your registration has already been submitted.");
		window.location.href = window.basePath;
	} else {
		$pageNumber = pageIndex;
	}

	$model.IsOptOut = true;
</script>

<PageSection>
	<div class="row justify-content-center">
		<div class="col-md-12">
			<h2 class="text-center">Nuix Shareholder Class Action</h2>
			<h1 class="text-center">Online Opt Out Form</h1>
		</div>
	</div>

	<hr style="border-color:#E6692D" />

	<p class="bold">Online Opt Out Form</p>
	<div class="notice">
		<Notice disabled {stage} />
	</div>

	<Signature
		{stage}
		bind:signature={$model.OptOut.Signature}
		bind:dateSignature={$model.OptOut.DateSignature}
		bind:consent={$model.OptOut.Consent}
		firstName={$model.Contact.FirstName}
		surname={$model.Contact.Surname}
	/>
</PageSection>

{#if !disabled}
	<div class="form-group form-row">
		<div class="col-md-12 last">
			<NavigationButtons {persistUrl} {previousPage} {nextPage} {nextPageLabel} pageName={title} tealiumTag={true}
			></NavigationButtons>
		</div>
	</div>
{/if}

<style>
	.notice {
		border: 1px solid #efefef;
		padding: 20px;
		border-radius: 6px;
		background-color: #fff;
		margin-bottom: 40px;
	}
</style>
